import type { Route } from '../types.tsx';

const applyLazyOpts = (route: Route) => {
	if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
		const hydratedRoute = { ...route, ...route.lazyOpts() };
		delete hydratedRoute.lazyOpts;
		return hydratedRoute;
	}
	return route;
};

export default applyLazyOpts;
